<template>
    <div class="message-title">
        <div class="message-title-label">
            <AttendeeOnline v-if="isOnline" />
            <a v-if="url" :href="url">{{title}} 
                <i class="message-title-hover-hint icon-share-alt"></i>
            </a>
            <span v-else>{{title}}</span>
        </div>
         <div v-if="message && (message.appointment || message.meeting)"
            class="message-title-time smallprint">
            <template v-if="message.appointment">{{asDateTimeStamp(message.appointment.start_time)}}</template>
            <template v-if="message.meeting">{{asDateTimeStamp(message.meeting.start_time)}}</template>

            <div v-if="message.meeting && message.meeting.deleted_at"
                class="message-title-deleted"
            >
                This meeting has been cancelled.
            </div>
        </div>
    </div>
</template>

<script>
/* Given a MessageDetail object, display the appropriate descriptive label
 * - If appointment, show the appointment title and start/end time?
 * - If meeting, show "Meeting" and the start time
 * - Else ~ Attendee - select the attendee that isn't 'me'
 */
import {mapGetters} from "vuex";
import { asDateTimeStamp } from "@/components/DateTime";
import AttendeeOnline from "@/components/AttendeeOnline";
import {nameAndOrganisation} from "@/utils/Attendee";
// import {buildThreadTitle} from "@/utils/Message";

export default {
    name: "MessageTitle",
    props: {
        message: Object,
        me: Object,
        url: {
            type: String,
            required: false,
        },
        long: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    components: {
        AttendeeOnline,
    },
    methods: {
        asDateTimeStamp,
        nameAndOrganisation,
    },
    computed: {
        title() {
            if (!this.message || !this.me) { return null; }

            const thread = this.threadForRoom;
            if (thread) {
                if (thread.appointment) {
                    return thread.appointment.name;
                } else if (thread.meeting) {
                    const tMeeting = thread.meeting;
                    if (tMeeting.booker_id == this.me.id) {
                    return `Meeting: ${tMeeting.attendee_name} (${tMeeting.attendee_organisation_name})`;
                } else {
                    return `Meeting: ${tMeeting.booker_name} (${tMeeting.booker_organisation_name})`;
                }
                } else {
                    if (this.otherAttendee) {
                        if (this.long) {
                            return nameAndOrganisation(this.otherAttendee);
                        } else {
                            return this.otherAttendee.full_name;
                        }
                    }
                }
            }
            return "Unknown";
        },
        appointment() {
            if (!this.message || !this.me) { return null; }
            if (this.threadForRoom) {
                if (this.threadForRoom.appointment) { return this.threadForRoom.appointment; }
            } else {
                return this.message.appointment;
            }
            return null;
        },
        meeting() {
            if (!this.message || !this.me) { return null; }
            if (this.threadForRoom) {
                if (this.threadForRoom.meeting) { return this.threadForRoom.meeting; }
            } else {
                return this.message.meeting;
            }
            return null;
        },
        otherAttendee() {
            // Return the 'other' person in a message/thread
            if (!this.message || !this.me) { return null; }
            if (this.threadForRoom) {
                if (this.threadForRoom.sender_id == this.me.id) {
                    return this.threadForRoom.attendee;
                } else {
                    return this.threadForRoom.sender;
                }
            }
            if (this.message.sender_id == this.me.id) {
                return this.message.attendee;
            } else {
                return this.message.sender;
            }
        },
        isOnline() {
            // Only show online status for 1:1, not appointments/meetings
            if (!this.appointment && !this.meeting) {
                if (this.otherAttendee) {
                    return this.isAttendeeOnline(this.otherAttendee.id);
                }
            }
            return false;
        },
        threadForRoom() {
            return this.threadCache(this.message.thread ? this.message.thread : this.message.room);
        },
        ...mapGetters({
            threadCache: "messages/threadCache",
            isAttendeeOnline: "messages/isAttendeeOnline",
        })
    },
}
</script>

<style>
.message-title {
    /* border-bottom: 1px solid #eee; */
    border-bottom: none;
    margin-bottom: 5px;
    padding-bottom: 5px;
}
a:hover  .message-title,
.router-link-active .message-title {
    border-bottom: 1px solid #ddd;
}
.message-title-label {
    font-weight: bold;
}
.message-title-time {
    display: block;
    margin-top: 5px;
}
.message-title-hover-hint {
    display: none;
}
a:hover .message-title-hover-hint {
    display: inline-block;
}
</style>
